import { EShape } from "../e-shape";

export interface EShapes {
	CURRENT: EShape | null;
}

export const EShapes: EShapes = {
	CURRENT: null
};
